export default {"src":"/_next/static/media/Instagram.d84c41f1.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};